<script setup>
import { defineProps, defineEmits } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps(["data"])
const emit = defineEmits(['edit-provider'])
</script>

<template>
  <div class="dropdown">
    <button class="btn btn-link dropdown-toggle p-0 options-btn" type="button" data-bs-toggle="dropdown">
      <FontAwesomeIcon :icon="['fas', 'ellipsis-vertical']" />
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <a class="dropdown-item" href="#" @click.prevent="$router.push({ name: 'ProviderProfile', params: { name: props.data.name } })">
          <FontAwesomeIcon class="me-2" :icon="['fas', 'eye']" />
          View Profile
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#" @click.prevent="emit('edit-provider', props.data)">
          <FontAwesomeIcon class="me-2" :icon="['fas', 'edit']" />
          Edit Profile
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          <FontAwesomeIcon class="me-2" :icon="['fas', 'download']" />
          Export IPs
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.options-btn {
  color: #6B7280 !important;
  border: none !important;
  background: none !important;
  padding: 0.25rem !important;
  line-height: 1 !important;
  font-size: 0.9rem !important;
}

.options-btn:hover {
  color: #9CA3AF !important;
}

.options-btn::after {
  display: none !important;
}
</style>
